import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";
import TableCustomViewOptionsStore from "./TableCustomViewOptionsStore";

const PrintOptionFrozenColumnsForEachPage: FunctionComponent = observer(function PrintOptionFrozenColumnsForEachPage(props) {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		options: {
			printFrozenColumnsForEachPage,
		},
		setPrintFrozenColumnsForEachPage,
	} = optionsStore as TableCustomViewOptionsStore;

	return (
		<>
			{isDefined(printFrozenColumnsForEachPage) && (
				<CheckboxOption
					label="ViewPreferences_printFrozenColumnsForEachPage"
					onChange={setPrintFrozenColumnsForEachPage}
					optionValue={printFrozenColumnsForEachPage}
					paddingLeft={0}
				/>
			)}
		</>
	);
});

export default PrintOptionFrozenColumnsForEachPage;